import React, {FC, useRef, useState} from 'react';

import Map from '@geomatico/geocomponents/Map/Map';

/****** START OF COG SETUP ******/
import maplibregl, { StyleSpecification } from 'maplibre-gl';
import {cogProtocol} from '@geomatico/maplibre-cog-protocol';
import ValueTooltip from '../../components/ValueTooltip';
import {MapRef} from 'react-map-gl/maplibre';
import HeightFormatter from '../../components/HeightFormatter';

maplibregl.addProtocol('cog', cogProtocol);

const sources: StyleSpecification['sources'] = {
  'hipsoSource': {
    type: 'raster',
    url: 'cog://https://cdn.geomatico.es/pirineo_dem_cog_256.tif#color:BrewerBrBG10,1300,2400,c-',
    tileSize: 256
  },
  'hillshadeSource': {
    type: 'raster-dem',
    url: 'cog://https://cdn.geomatico.es/pirineo_dem_cog_256.tif#dem',
    tileSize: 256
  },
  'terrainSource': {
    type: 'raster-dem',
    url: 'cog://https://cdn.geomatico.es/pirineo_dem_cog_256.tif#dem',
    tileSize: 256
  },
};

const layers: StyleSpecification['layers'] = [{
  source: 'hipsoSource',
  id: 'imageLayer',
  type: 'raster'
},{
  source: 'hillshadeSource',
  id: 'hillshadingLayer',
  type: 'hillshade'
}];

const terrain = {
  source: 'terrainSource'
};

/****** END OF COG SETUP ******/


export type MainContentProps = {
  mapStyle: string
};

const INITIAL_VIEWPORT = {
  latitude: 42.502312,
  longitude: 0.990829,
  zoom: 14,
  bearing: 0,
  pitch: 60
};

const MainContent: FC<MainContentProps> = () => {
  const mapRef = useRef<MapRef>(null);
  const [viewport, setViewport] = useState(INITIAL_VIEWPORT);

  return <Map
    ref={mapRef}
    mapLib={maplibregl}
    mapStyle={undefined}
    viewport={viewport}
    onViewportChange={setViewport}
    sources={sources}
    layers={layers}
    terrain={terrain}
  >
    <ValueTooltip mapRef={mapRef} url="https://cdn.geomatico.es/pirineo_dem_cog_256.tif" formatter={HeightFormatter}/>
  </Map>;
};

export default MainContent;
